module.exports = __webpack_public_path__ + "media/images/city/045-space-needle-c07e0d6d06aa315e387a25fffc401a3a.svg";